/**
 * Metering Reducer
 *
 * State shape for metering data managed by Redux.
 * Uses remote resource reducer helpers for async data management.
 *
 * State Structure (example for contracted capacity):
 * meteringOverviewContracted: {
 *   value: { capacityGiB: 8200, subscriptionPeriodMonths: 24, renewalInDays: 325 },
 *   loading: false,
 *   error: null
 * }
 *
 * Object Reducers (for single values):
 *
 * Array Reducers (for lists):
 * - meteringTableDetails: Details table rows
 */

import createRemoteArrayResourceReducer from "./helpers/createRemoteArrayResourceReducer";
import createRemoteObjectResourceReducer from "./helpers/createRemoteObjectResourceReducer";

// Single object reducers for overview cards
// Each manages: value (data), loading (pending state), error (rejection state)
export const meteringOverviewContracted = createRemoteObjectResourceReducer(
  "METERING_OVERVIEW_CONTRACTED"
);

// Array reducers for charts and tables
// Each manages: value (array of items), loading, error

export const meteringTableDetails = createRemoteArrayResourceReducer(
  "METERING_TABLE_DETAILS"
);

// metering contracts
export const meteringTableContracts = createRemoteArrayResourceReducer(
  "METERING_TABLE_CONTRACTS"
);

// Reducer for Contract Grouped by Customer
export const meteringContractsByCustomer = createRemoteArrayResourceReducer(
  "METERING_CONTRACTS_BY_CUSTOMER"
);

export const addMeteringAssets = createRemoteObjectResourceReducer(
  "ADD_METERING_ASSETS"
);

//capacity csv donload
export const getCapacityReportCSV = createRemoteObjectResourceReducer(
  "GET_CAPACITY_REPORT_CSV"
);

//contracts csv downloads
export const getContractsReportCSV = createRemoteObjectResourceReducer(
  "GET_CONTRACTS_REPORT_CSV"
);
